import { axiosIns } from './index';
import { ApiResponse } from '../typings/ApiResponse';
import { ActivityResponseData } from '../typings/ActivityTypes';

const getActivityFeed = async (
  partnerId: string,
  page: number,
  limit: number
): Promise<ApiResponse<ActivityResponseData>> => {
  const response = await axiosIns.get(`carehome/activity-log/${partnerId}`, {
    params: {
      page,
      limit,
    },
  });
  return response.data;
};

export default getActivityFeed;
